export default __webpack_public_path__ + "static/media/sale-year.b300fc3a.svg";